import { NumberInputProps } from '../types';

/**
 * Check if the units should be rendered
 * @param unit - The unit of the input
 * @param displayValue - Whether the value is displayed
 * @returns Whether the units should be rendered
 */
export const shouldRenderUnits = (props: NumberInputProps) =>
  props.unit && !props.displayValue;
